import { SearchPlace } from '@/types/api/services/search';
import { Place } from '@/types/state/shared';
import { createContext, ReactNode, useContext, useState } from 'react';
import { adapter } from './AssociationDrawer.helpers';
import { PlaceWithAssociation, UseAssociationDrawerManagerOutput } from './AssociationDrawer.types';

const useAssocationDrawerManager = () => {
  const [place, setPlace] = useState<PlaceWithAssociation | null>(null);
  const [open, setOpen] = useState<boolean>(false);

  function handleOnClose() {
    setOpen(false);
  }

  function handleOnOpen(place: SearchPlace | Place) {
    const placeWithAssociations = adapter(place);

    if (!placeWithAssociations) {
      place && setPlace(null);
      return;
    }

    setPlace(placeWithAssociations);
    setOpen(true);
  }

  return {
    open,
    place,
    onOpen: handleOnOpen,
    onClose: handleOnClose,
  };
};

export const AssociationDrawerContext = createContext<UseAssociationDrawerManagerOutput>({
  place: undefined,
  open: false,
  onClose: () => {},
  onOpen: () => {},
});

export const useAssocationDrawerContext = () => {
  const context = useContext(AssociationDrawerContext);

  if (!context) {
    throw new Error('useAssocationDrawerContext must be used within a AssocationDrawerProvider');
  }

  return context;
};

export const AssocationDrawerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <AssociationDrawerContext.Provider value={useAssocationDrawerManager()}>
      {children}
    </AssociationDrawerContext.Provider>
  );
};
